import React, { useState, useEffect } from 'react';
import { i18n } from 'fishx';
import get from 'lodash/get';

import { Card, Select, Form } from '@whalecloud/fdx';
import PlanDetail from './PlanDetail';

import { renderPrice } from '@/utils';
import detailSvg from '@/assets/img/dscmPortal/offerDetails.svg';

import styles from './index.module.less';

const SubsPlanCard = props => {
  const { cardInfo = {}, isSelected, onClick, onDppChange, form } = props;
  const dppOfferList = get(cardInfo, 'dppOfferDtoList') || get(cardInfo, 'offerExtMap.dppOfferDtoList') || [];
  const defaultDisplayRentPrice = dppOfferList.find(dpp => dpp.defaultFlag === 'Y').mrc || get(dppOfferList[0], 'mrc');
  const comboUnitOfferDtoList = get(cardInfo, 'offerExtMap.comboUnitOfferDtoList') || [];
  const { getFieldDecorator, getFieldValue } = form;
  const [comVisible, setComVisible] = useState(false);

  const [comMask, setComMask] = useState(false); // 判断offer是否可以被订购
  const [displayRentPrice, setDisplayRentPrice] = useState(defaultDisplayRentPrice);
  const servType = get(cardInfo, 'servType') || get(cardInfo, 'offerExtMap.servType') || '';
  const getDppDefault = () => dppOfferList.find(dpp => dpp.defaultFlag === 'Y').offerId || get(dppOfferList[0], 'offerId');

  const handleClick = e => {
    e.stopPropagation();
    setComVisible(!comVisible);
  };

  const changeDpp = value => {
    const currentDpp = dppOfferList.find(dpp => get(dpp, 'offerId') === value);
    setDisplayRentPrice(get(currentDpp, 'mrc'));
    onDppChange(currentDpp);
  };

  const changeSubsPlan = () => {
    const maskFlag = comboUnitOfferDtoList.some(comboUnitOfferItem => comboUnitOfferItem.isCannotOrder === 'Y');
    onClick(maskFlag ? {} : cardInfo);
    changeDpp(getFieldValue('selectDpp') || getDppDefault() || {});
  };

  useEffect(() => {
    const maskFlag = comboUnitOfferDtoList.some(comboUnitOfferItem => comboUnitOfferItem.isCannotOrder === 'Y');
    setComMask(maskFlag);
  }, [cardInfo]);

  return (
    <div className={`${styles.subsPlanCard} ${isSelected && !comMask && styles.offerSelect}`} onClick={changeSubsPlan}>
      <Card
        className={styles.cardItem}
        title={cardInfo.offerName}
        hoverable
        extra={(
          <div>
            {['79', '26', '917'].includes(`${servType}`) && !cardInfo.isCombo && (
              <div className={styles.detailDiv} onClick={handleClick}>
                <img src={detailSvg} alt="" />
                <span>{i18n('SELECT_OFFER_DETAILS')}</span>
              </div>
            )}
          </div>
        )}
        cover={comMask ? <div className={styles.offerMask} /> : null}
      >
        {getFieldDecorator('selectDpp')(
          <Select className={styles.selectBox} onChange={changeDpp} defaultValue={getDppDefault()}>
            {dppOfferList.map(dpp => (
              <Select.Option value={get(dpp, 'offerId')} key={get(dpp, 'offerId')}>
                {get(dpp, 'offerName')}
              </Select.Option>
            ))}
          </Select>
        )}
        <div className={styles.priceItemBox}>
          <span className={styles.priceTitle}>{i18n('SELECT_OFFER_PLAN_PRICE')}</span>
          <span className={styles.priceText}>{renderPrice(displayRentPrice)}</span>
        </div>
        {comVisible && <PlanDetail cardInfo={cardInfo} onCancel={handleClick} servType={`${servType}`} />}
      </Card>
    </div>
  );
};

export default Form.create()(SubsPlanCard);
